import request from './../utils/request';

export function index(params) {
  return request({
    url: '/warehouses',
    method: 'GET',
    params
  });
}

export function show(id) {
  return request({
    url: '/warehouses/' + id,
    method: 'GET'
  });
}

export function store(data) {
  return request({
    url: '/warehouses',
    method: 'POST',
    data
  });
}

export function update(data) {
  return request({
    url: '/warehouses/' + data.id,
    method: 'PUT',
    data
  });
}

export function destroy(id) {
  return request({
    url: '/warehouses/' + id,
    method: 'DELETE'
  });
}

export function maininventory(params) {
  return request({
    url: '/warehouses/maininventory',
    method: 'GET',
    params
  });
}

export function inventory(params) {
  return request({
    url: '/warehouses/inventory',
    method: 'GET',
    params
  });
}

export function userinventory(params) {
  return request({
    url: '/warehouses/userinventory',
    method: 'GET',
    params
  });
}